require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./features-customisation.json") })
        }
      }, "path---features-customisation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---features-customisation!./.cache/json/features-customisation.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---features-customisation!./.cache/json/features-customisation.json
// module chunks = 231608221292675